import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
import {
  BASE_NODE_URL,
  GET_PERMISSION_PRESET,
} from "../../../Constants/Config";

// Load permission preset data from localStorage if available
let storedPermissionPresetData = [];
try {
  const stored = localStorage.getItem("permissionPresetData");
  if (stored) {
    storedPermissionPresetData = JSON.parse(stored);
  }
} catch (e) {
  storedPermissionPresetData = [];
}

const initialState = {
  loading: false,
  permissionPresetData: storedPermissionPresetData,
  successMessage: "",
  error: "",
};

// Generate pending , fulfilled and rejected action type
export const fetchPermissionPresetData = createAsyncThunk(
  "permissionPreset/fetchPermissionPresetData",
  async (data, { rejectWithValue }) => {
    const {
      token,
      token_id,
      login_type,
      session_id,
      merchant_id,
      login_merchant_id,
      login_user_email,
    } = data;
    const payloadData = {
      merchant_id,
      store_email: login_user_email,
      token,
      token_id,
      login_type,
      session_id,
      login_merchant_id,
    };
    try {
      const response = await axios.post(
        BASE_NODE_URL + GET_PERMISSION_PRESET,
        payloadData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

    // console.log("response permission preset", response);
      if (response?.data?.status && response?.data?.data?.length > 0) {
        return response?.data?.data;
      } else {
        return [];
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const permissionPresetSlice = createSlice({
  name: "permissionPreset",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchPermissionPresetData.pending, (state) => {
      state.permissionPresetData = [];
      state.loading = true;
      state.error = "";
    });
    builder.addCase(fetchPermissionPresetData.fulfilled, (state, action) => {
      state.loading = false;
      console.log("action.payload permission preset", action.payload);
      state.permissionPresetData = action.payload;
      try {
        localStorage.setItem(
          "permissionPresetData",
          JSON.stringify(action.payload || [])
        );
      } catch (e) {}
      state.error = "";
    });
    builder.addCase(fetchPermissionPresetData.rejected, (state, action) => {
      state.loading = false;
      state.permissionPresetData = [];
      try {
        localStorage.removeItem("permissionPresetData");
      } catch (e) {}
      state.error = action.error.message;
    });
  },
});

export default permissionPresetSlice.reducer;
